import script from "./ux-datagrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ux-datagrid.vue?vue&type=script&setup=true&lang=js"

import "./ux-datagrid.vue?vue&type=style&index=0&id=3c1da7e1&lang=css"

const __exports__ = script;

export default __exports__